const accordion = require('van11y-accessible-accordion-aria');
